import {stopPropagationEvent} from '../../../common/shared/utils/stopPropagationEvent.function';
import {twMerge} from '../../../common/twMerge';
import {
  LINK_ANDROID_STORE,
  LINK_IOS_STORE,
} from '../../../domain/bridge/applink/constant';
import {StaticImage} from '../../atoms/StaticImage/StaticImage';
import {StaticImageType} from '../../atoms/StaticImage/StaticImageType.enum';
import {AppDownloadProps} from './AppDownloadProps.interface';

export function AppDownload({
  isMobile,
  isViewerEnd = false,
  onClickAppLink,
  isFullBannerOnPc,
  className,
  ...props
}: AppDownloadProps) {
  return (
    <div className="mx-11pxr">
      {isMobile && !isViewerEnd && (
        <div
          className={twMerge('mb-24pxr', className)}
          onClick={onClickAppLink}
          {...props}
        >
          <div className="h-110pxr overflow-hidden rounded-16pxr bg-static-etc-bg-da">
            <StaticImage
              imageType={StaticImageType.InstallMw}
              className="h-full w-full object-contain"
            />
          </div>
        </div>
      )}
      {isMobile && isViewerEnd && (
        <div
          className={twMerge('min-h-98pxr py-15pxr', className)}
          onClick={e => {
            stopPropagationEvent(e);
            onClickAppLink(e);
          }}
          {...props}
        >
          <div className="h-68pxr overflow-hidden rounded-16pxr bg-static-etc-bg-da px-5pxr">
            <StaticImage
              imageType={StaticImageType.InstallBannerDaMw}
              className="block h-full w-full object-contain"
            />
          </div>
        </div>
      )}
      {!isMobile && (
        <div
          className={twMerge(isFullBannerOnPc && 'px-0', className)}
          {...props}
        >
          <div className="relative overflow-hidden rounded-16pxr bg-static-etc-bg-da px-74pxr">
            <StaticImage
              imageType={StaticImageType.InstallPc}
              className="h-full w-full"
            />
            <div className="absolute left-0 top-56pxr flex w-full justify-center">
              <a
                href={LINK_ANDROID_STORE}
                target="_blank"
                rel="noopener noreferrer"
              >
                <StaticImage
                  imageType={StaticImageType.PlayStore}
                  className="mr-4pxr h-32pxr w-108pxr"
                />
              </a>
              <a
                href={LINK_IOS_STORE}
                target="_blank"
                rel="noopener noreferrer"
              >
                <StaticImage
                  imageType={StaticImageType.AppStore}
                  className="h-32pxr w-100pxr overflow-hidden rounded-16pxr"
                />
              </a>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
